var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "6 2 13 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.98h-3.33a.657.657 0 0 1-.67-.662V3H7v17h11zm-.801-1.013-2.17-2.346v2.346zM14.463 2l.04.001c.334.013.65.159.883.409l3.245 3.476c.146.157.252.346.312.551A.8.8 0 0 1 19 6.77l.001.064v12.809c0 .75-.582 1.357-1.3 1.357H7.3c-.718 0-1.3-.608-1.3-1.357V3.357C6 2.607 6.582 2 7.3 2h7.163M8.5 10h8a.5.5 0 1 1 0 1h-8a.5.5 0 1 1 0-1m0 4h8a.5.5 0 1 1 0 1h-8a.5.5 0 1 1 0-1"
  })));
};
export default SvgDocument;